(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* Pure RV — cart-page live progress bar updater */
  (function () {
    function moneyFmt(cents) {
      var amount = cents / 100;
      if (amount % 1 === 0) return '$' + amount.toFixed(0);
      return '$' + amount.toFixed(2);
    }

    function updateBar(currentCents) {
      var bar = document.querySelector('[data-prv-fs-bar]');
      if (!bar) return;
      var threshold = parseInt(bar.dataset.thresholdCents, 10) || 3500;
      var remaining = Math.max(0, threshold - currentCents);
      var pct = Math.min(100, Math.round((currentCents / threshold) * 100));

      var fill = bar.querySelector('[data-prv-fs-fill]');
      var copy = bar.querySelector('[data-prv-fs-copy]');
      var track = bar.querySelector('.prv-fs-bar__track');

      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      if (copy) {
        if (remaining === 0) {
          copy.innerHTML =
            '<svg class="prv-fs-bar__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
            '<span><strong>You unlocked FREE shipping</strong></span>';
        } else if (pct >= 50) {
          copy.innerHTML =
            '<span>Almost there — only <strong data-prv-fs-amount>' +
            moneyFmt(remaining) +
            '</strong> away from FREE shipping</span>';
        } else {
          copy.innerHTML =
            '<span>Add <strong data-prv-fs-amount>' +
            moneyFmt(remaining) +
            '</strong> more for FREE shipping</span>';
        }
      }
      bar.dataset.currentCents = String(currentCents);
    }

    async function fetchCartAndUpdate() {
      try {
        var r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!r.ok) return;
        var cart = await r.json();
        updateBar(cart.total_price);
      } catch (e) { /* silent */ }
    }

    function bind() {
      var bar = document.querySelector('[data-prv-fs-bar]');
      if (!bar) return;

      // Listen for theme cart events
      document.addEventListener('cart:updated', fetchCartAndUpdate);
      document.addEventListener('cart:item-removed', fetchCartAndUpdate);
      document.addEventListener('cart:item-added', fetchCartAndUpdate);

      // Observe the cart total node for any change as a fallback
      var totalNode = document.querySelector('[ref="cartTotal"], [data-cart-subtotal]');
      if (totalNode) {
        var mo = new MutationObserver(fetchCartAndUpdate);
        mo.observe(totalNode, { childList: true, subtree: true, characterData: true });
      }

      // Refresh once on load to pick up cart state changed elsewhere
      setTimeout(fetchCartAndUpdate, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }

    // Re-bind after Shopify section morph
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
